import { Injectable } from "@angular/core";
import { DialogLike, DialogService } from "@obg/mat.ui.core";
import { DeviceConfigService } from "@obg/ngx.global";
import { map } from "rxjs/operators";

import { MIGRATED_USER_WELCOME_DIALOG_ID } from "../../login-flow-dialog/login-flow-dialog.const";

import { MigratedUserWelcomeContainer } from "./migrated-user-welcome-container";

@Injectable({
	providedIn: "root",
})
export class WelcomeMigratedUserDialogService {
	constructor(
		private dialogService: DialogService,
		private deviceConfigService: DeviceConfigService
	) {}

	MIGRATED_USER_WELCOME_DIALOG: DialogLike<MigratedUserWelcomeContainer> = {
		dialogId: MIGRATED_USER_WELCOME_DIALOG_ID,
		dialogComponentType: MigratedUserWelcomeContainer,
		onClose$: (c) => c.close,
		onBusy$: (c) => c.busy.pipe(map((isBusy) => ({ isBusy }))),
	};

	open() {
		return () => {
			this.dialogService.openComponent(this.MIGRATED_USER_WELCOME_DIALOG, {
				panelClass: "obg-m-migrated-user-welcome-dialog",
				data: {
					hideClose: true,
					hideFooter: true,
					navbar: false,
					navbarOptions: {
						hideBackButton: true,
					},
				},
				width: this.deviceConfigService.isDesktop() ? "initial" : "100vw",
				height: this.deviceConfigService.isDesktop() ? "initial" : "100vh",
				autoFocus: false,
				disableClose: true,
			});
		};
	}
}
